import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import fetchUser from '../api/user';

import User from 'modules/Auth/common/User.interface';

const useUser = (options?: Omit<UseQueryOptions<User>, 'queryKey'>) => {
    return useQuery({
        queryKey: ['user'],
        queryFn: fetchUser,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        ...options,
    });
};

export default useUser;
